import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';

import { Iconify } from 'src/components/iconify';
import { useLocale } from 'src/locales';
import { CONFIG } from 'src/global-config';
import { useTheme } from '@emotion/react';
import { useMediaQuery } from '@mui/material';

// ----------------------------------------------------------------------

export function ContactAssist({ sx, ...other }) {
  const { t } = useLocale();
  const language = localStorage.getItem('i18nextLng') || 'ar';
  const isRTL = language === 'ar';

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const imageSrc = isSmallScreen
    ? `${CONFIG.assetsDir}/assets/images/home/seo/Contact-Us/shahen-contact-banner-phone.webp`
    : `${CONFIG.assetsDir}/assets/images/home/seo/Contact-Us/shahen-contact-banner.webp`;

  // const bannerImageStyle = {
  //   '&::before': {
  //     content: '""',
  //     position: 'absolute',
  //     top: 0,
  //     left: 0,
  //     right: 0,
  //     bottom: 0,
  //     backgroundImage: `
  //     linear-gradient(to bottom, transparent 40%, #000 95%),
  //     url(${CONFIG.assetsDir}/assets/images/contact/riyadh-transport-company-location.png)
  //   `,
  //     backgroundSize: 'cover',
  //     backgroundRepeat: 'no-repeat',
  //     backgroundPosition: 'center center',
  //     zIndex: 0,
  //     transform: isRTL ? 'rotateY(180deg)' : 'none',
  //   },
  // };

  return (
    <Box component="section" {...other}>
      <Container
        sx={{
          textAlign: 'center',
          pt: { xs: 3, md: 10 },
          // pb: { xs: 5, md: 10 },
        }}
        maxWidth={false}
        disableGutters
      >
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            height: { md: 'calc(100vh - 10vh)', xs: 250 },
          }}
        >
          <Box
            component="img"
            src={`${CONFIG.assetsDir}/assets/images/home/seo/Contact-Us/shahen-contact-banner.webp`}
            // src={imageSrc}
            alt={t('contact-img1-title')}
            title={t('contact-img1-meta-desk')}
            sx={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              position: 'absolute',
              top: 0,
              left: 0,
              transform: isRTL ? 'rotateY(180deg)' : 'none',
            }}
          />
          <Container
            sx={{
              height: '100%',
              position: 'relative',
              display: 'flex',
              alignItems: 'flex-end',
              justifyContent: 'center',
              bgcolor: 'rgba(0, 0, 0, 0.5)',
              pb: { xs: 2, md: 6 },
            }}
            maxWidth={false}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                justifyContent: 'flex-end',
                alignItems: 'center',
                gap: { xs: 3, md: 5 },
              }}
            >
              {/* <Iconify
                icon="streamline-plump:customer-support-7"
                width={200}
                height={200}
                sx={{
                  alignSelf: 'center',
                  display: { xs: 'none', md: 'block' },
                  transform: isRTL ? 'rotateY(180deg)' : 'none',
                  zIndex: 1,
                }}
              /> */}
              <Typography
                variant="h2"
                component="h2"
                sx={{
                  color: 'common.white',
                  maxWidth: 1000,
                  zIndex: 1,
                  borderRadius: 2,
                  fontSize: { md: '2rem !important', xs: '1.3rem !important' },
                }}
              >
                {t('Were_pleased_to_connect_with_you')}
              </Typography>
            </Box>
          </Container>
        </Box>
      </Container>
    </Box>
  );
}

// ----------------------------------------------------------------------
